import React from "react";
import PropTypes from "prop-types";
import { H4 } from "theme/components/atoms/Typography/Heading";
import Breadcrumb from "theme/components/organisms/Breadcrumb";
import ResizedImage from "theme/components/atoms/ResizedImage";
import withGenderFilter from "theme/components/helpers/withGenderFilter";
import { compose, withProps, branch } from "recompose";
import branchServerClient from "web/core/branchServerClient";
import { Helmet } from "react-helmet-async";

const PaginatedPageHeader = ({
  name,
  breadcrumb,
  description,
  image,
  imageMedia,
  hideCategoryName,
  nameToDisplay,
}) => {
  return (
    <>
      <Helmet>
        <title>{nameToDisplay}</title>
      </Helmet>
      {imageMedia ? (
        <div className="paginated-page__headerfull">
          <div className="paginated-page__wrapper-background">
            {breadcrumb?.length > 0 && <Breadcrumb paths={breadcrumb} />}
            <ResizedImage
              itemProp="image"
              className="paginated-page__headerfull__image"
              src={imageMedia.url}
              srcset={imageMedia.srcset}
              alt={imageMedia.alt}
              format="categoryFullscreen"
              cover
            />
            <div className="paginated-page__headerfull__content">
              {!hideCategoryName && <H4 as="h1">{nameToDisplay}</H4>}
              <span>{description}</span>
            </div>
          </div>
        </div>
      ) : image ? (
        <div className="paginated-page__headerfull">
          <div className="paginated-page__wrapper-background">
            {breadcrumb?.length > 0 && <Breadcrumb paths={breadcrumb} />}
            <ResizedImage
              itemProp="image"
              className="paginated-page__headerfull__image"
              src={image}
              alt={name}
              format="categoryFullscreen"
              cover
            />
            <div className="paginated-page__headerfull__content">
              {!hideCategoryName && <H4 as="h1">{nameToDisplay}</H4>}
              <span>{description}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="paginated-page__header">
          <div className="paginated-page__wrapper-background">
            {breadcrumb?.length > 0 && <Breadcrumb paths={breadcrumb} />}
            {!hideCategoryName && <H4 as="h1">{nameToDisplay}</H4>}
          </div>
        </div>
      )}
    </>
  );
};

PaginatedPageHeader.propTypes = {
  name: PropTypes.string.isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
};

export default compose(
  branchServerClient(
    withProps((props) => ({ nameToDisplay: props.name })),
    compose(
      withGenderFilter(),
      withProps((props) => ({
        nameToDisplay: props.currentGenderLabel
          ? `${props.name} ${props.currentGenderLabel}`
          : props.name,
      })),
      branch(
        (props) => props.shop.id === "b2c_en" || props.shop.id === "b2b_en",
        withProps((props) => {
          if (typeof props.currentGenderLabel === "undefined") {
            return {};
          }

          return {
            nameToDisplay:
              props.currentGenderLabel === "kids"
                ? `${props.currentGenderLabel.slice(0, -1)}'s ${props.name}`
                : `${props.currentGenderLabel}'s ${props.name}`,
          };
        })
      )
    )
  )
)(PaginatedPageHeader);
